module.exports = __webpack_public_path__ + "d8bb65.png";